module.exports = __webpack_public_path__ + "vue-app/img/curve-bleu.700c2f00.svg";